'use client';
import { isRequest } from '../../utils/guards.js';

const getInputCredentials = (input)=>isRequest(input) && 'credentials' in Request.prototype ? input.credentials : undefined;

export { getInputCredentials };
//# sourceMappingURL=getInputCredentials.js.map
